import { MdOutlineWorkspacePremium } from "react-icons/md";
import { HiLightBulb } from "react-icons/hi";
import { GrGroup } from "react-icons/gr";

export const valuesList = [
  {
    values: "Quality",
    Icon: <MdOutlineWorkspacePremium/>,
    desc: "Delivering excellence in every project"
  },
  {
    values: "Innovation",
    Icon: <HiLightBulb/>,
    desc: "Adopting advanced techniques and technologies."
  },
  {
    values: "Customer Focus",
    Icon: <GrGroup/>,
    desc: "Putting client satisfaction at the heart of our services"
  }
];
